var _radialGradient, _radialGradient2, _radialGradient3, _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGraphicEmailBounced = function SvgGraphicEmailBounced(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "2in",
    viewBox: "0 0 216 144",
    width: "3in",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 82.58,
    cy: 113.93,
    gradientUnits: "userSpaceOnUse",
    r: 102.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 74.73,
    cy: 149.39,
    gradientUnits: "userSpaceOnUse",
    r: 150.75
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 129.21,
    cy: 117.26,
    gradientTransform: "matrix(1 0 0 .7 0 35.37)",
    gradientUnits: "userSpaceOnUse",
    r: 112.67
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#cdcdd4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#cdcdd4",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#cdcdd4",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#cdcdd4",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdd4",
    stopOpacity: 0.2
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 179.95,
    x2: 93.75,
    y1: 32.17,
    y2: 118.37
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ff624a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff3c75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ff298a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m67.9 55.29a9.51 9.51 0 0 1 -9.47 9.51h-38.07a7.27 7.27 0 0 1 0-14.54 7.15 7.15 0 0 1 1.74.22 7.24 7.24 0 0 1 -.2-1.69 7.49 7.49 0 0 1 11.74-6.17 12.6 12.6 0 0 1 24.79 3.16 9.51 9.51 0 0 1 9.47 9.51z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m192.55 51.34a10.8 10.8 0 0 0 -2.62.32 11.15 11.15 0 0 0 .29-2.53 11.31 11.31 0 0 0 -17.69-9.32 19 19 0 0 0 -37.36 4.78 14.27 14.27 0 1 0 0 28.53h57.38a10.89 10.89 0 1 0 0-21.78z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m24.87 72.66a22.54 22.54 0 0 1 22.45-22.66l120.77-.48a22.53 22.53 0 1 1 .18 45.06l-120.77.53a22.54 22.54 0 0 1 -22.63-22.45z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m184.76 79.26-14-34a9.94 9.94 0 0 0 -1.87-2.94 7.41 7.41 0 0 0 -.63-.62 3.11 3.11 0 0 0 -1-.62c-.92-.37-2.68-.93-5.57-1.78l-.34-.09c-10.52-3.07-30.78-8.36-31-8.42-3.15-.78-5.41-.78-7.35 0s-3.54 2.4-5.16 5.17c-.11.17-10.84 18.38-16 27.8l-.17.31c-1.41 2.56-2.25 4.17-2.66 5.08a3.46 3.46 0 0 0 -.27 1.13v.46l-.16.39.18.44a10 10 0 0 0 .73 3.08l14 33.94a3.55 3.55 0 0 0 .08.47 3.33 3.33 0 0 0 .94 1.62 10 10 0 0 0 2.52 1.91 7.42 7.42 0 0 0 1 .45l.3.12.29.09a10 10 0 0 0 5.57.16l.27-.06.22-.07a5.49 5.49 0 0 0 .84-.27l53.83-22.19a10 10 0 0 0 6.18-9.19 3.32 3.32 0 0 0 -.77-2.37z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m166.11 53.57a1.91 1.91 0 0 0 -2.64.63l-12.67 20.52h-.19a13.27 13.27 0 0 0 -12.13 2.21 16.94 16.94 0 0 0 -4.14 4.47l-.09.14-23.37-5.61a1.92 1.92 0 1 0 -.9 3.74l22.23 5.33-9.21 15.61a1.89 1.89 0 0 0 -.21 1.45 1.92 1.92 0 0 0 2.34 1.39 1.14 1.14 0 0 0 .26-.09 2 2 0 0 0 .92-.79l11.39-19.26c0-.07 4.37-7.17 12-4.93l21.56 5.62a2 2 0 0 0 2.34-1.38 1.92 1.92 0 0 0 -1.38-2.34l-17.52-4.55 12-19.51a1.92 1.92 0 0 0 .23-1.46 1.86 1.86 0 0 0 -.82-1.19z",
    fill: "#ffa266",
    opacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m140.19 49.19-.9.37-1.46-3.56a7.76 7.76 0 0 0 -14.34 5.91l1.51 3.56-.9.37a2.9 2.9 0 0 0 -1.58 3.79l3.71 9a2.89 2.89 0 0 0 3.77 1.57l16.13-6.65a2.89 2.89 0 0 0 1.58-3.79l-3.7-9a2.9 2.9 0 0 0 -3.82-1.57zm-13.12 1.24a3.88 3.88 0 0 1 7.17-3l1.47 3.57-7.17 3z",
    fill: "#f9f9fa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m49.78 84.9a2.42 2.42 0 0 0 -2.36 4.21c10.2 6.91 15.17 14.56 20 22a2.42 2.42 0 0 0 4.06-2.63c-4.85-7.48-10.33-15.92-21.34-23.38a1.82 1.82 0 0 0 -.36-.2zm-11.78-7.58a2.47 2.47 0 0 0 -.47-.29c-1.24-.59-2.46-1.13-3.67-1.62a2.43 2.43 0 0 0 -1.86 4.5c1.12.44 2.25.94 3.4 1.49a2.42 2.42 0 0 0 2.6-4.08zm44.91 23.68a2.42 2.42 0 0 1 -2.57-4 67.1 67.1 0 0 1 13.18-9 2.36 2.36 0 0 1 3.28 1 2.42 2.42 0 0 1 -1 3.27 62.55 62.55 0 0 0 -12.25 8.38 2 2 0 0 1 -.64.35z",
    fill: "#b1b1bc"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicEmailBounced);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_email_bounced.26e87bb2b3ec038a7787357309c1bc88.svg";